import React from "react"
import {useStaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"


const Header = (props) =>{

	const query = useStaticQuery(graphql`
  query {
    headerPC:file(relativePath: { eq: "header_pc.png" }) {
      childImageSharp {
        fixed(width: 1920) {
          ...GatsbyImageSharpFixed
        }
      }
    },
    headerSP:file(relativePath: { eq: "header_sp.png" }) {
      childImageSharp {
        fixed(width: 1300) {
          ...GatsbyImageSharpFixed
        }
      }
    }
  }
  `)
  
	return(
    
    <header className="Header">
      <div className="Header Header__IMG Header__IMG_Device_pc pc">
        <Img fixed={query.headerPC.childImageSharp.fixed} />
      </div>
      <div className="Header Header__IMG Header__IMG_Device_sp sp">
        <Img fixed={query.headerSP.childImageSharp.fixed} />
      </div>
    </header>
  )

}

export default Header
